export default {
  path: '/exp',
  name: 'exp',
  component: () => import('@/views/Page.vue'),
  children: [
    {
      path: 'list',
      name: 'list',
      component: () => import('@/components/exp/List.vue'),
      meta: {
        title: '报销审批'
      }
    },
     //带同意拒绝 代办
    {
      path: 'upcoming/details',
      name: 'details',
      component: () => import('@/components/exp/ApprovalDetails.vue'),
      meta: {
        title: '审批详情'
      }
    },
     //已办
    {
      path: 'completed/details',
      name: 'completedDetails',
      component: () => import('@/components/exp/CompletedDetails.vue'),
      meta: {
        title: '审批详情'
      }
    },
    {
      path: 'record',
      component: () => import('@/components/exp/Record.vue'),
      meta: {
        title: '审批记录'
      }
    },
    // 发票修改详情
    {
      path: 'invoiceDetails',
      component: () => import('@/components/exp/InvoiceDetails.vue'),
      meta: {
        title: '发票、支付凭证修改详情'
      }
    }
  ]
}
